import React from 'react';
import { FelaComponent } from 'react-fela';

import withPageContext from '../pageContext';

import SEO from '../components/SEO';
import HeaderScroller from '../components/HeaderScroller';
import ContactsSection from '../components/Event/ContactsSection';
import Footer from '../components/Footer';

import FaqHero from '../components/Faq/FaqHero';
import FaqSection from '../components/Faq/FaqSection';

import { LinkType } from '../components/Link/Link.style';

const links = [
    { to: '/', labelId: 'home.menu.top', type: LinkType.GATSBY },
    { to: '/features', labelId: 'home.menu.features', type: LinkType.GATSBY },
    { to: '/festival', labelId: 'home.menu.festival', type: LinkType.GATSBY },
    { to: '/conference', labelId: 'home.menu.conference', type: LinkType.GATSBY },
    { to: '#contacts', labelId: 'home.menu.contacts', asButton: true, type: LinkType.NATIVE },
];

const style = ({ theme }) => ({
    minHeight: '100vh',
    backgroundColor: theme.colors.greyLight,
});

const FaqPage = () => (
    <FelaComponent style={style}>
        <SEO title="title.faq" desc="description.faq" />
        <HeaderScroller links={links} inBlackStyle />
        <main>
            <FaqHero />
            <FaqSection />
        </main>
        <ContactsSection titleId="home.contacts.title" />
        <Footer />
    </FelaComponent>
);

export default withPageContext(FaqPage);
